'use strict';

function MainDashboardInterstitial() {
  this.id = null;
  this.node = null;
  this.extends = [Interstitial // instantiates _product
  ];
  this.contentId = ''; // 'main-dashboard' or 'main-dashboard-crypto-tiers-referral' (defined in pug file)

  this.init = function () {
    this._super();

    this._productSettings = new ProductSettings(this.presenter);

    var MEMBER_CONTENTS_KEY = this.contentId + '-interstitial';

    // NOTE June 2021: this interstitial is not currently being displayed to users.

    if (this._productSettings.hasViewedContent(MEMBER_CONTENTS_KEY) || this.hasViewedRelatedContent()) {
      this.history = new History();
      this.history.replaceUrl(Product.shortcutMappings['main-dashboard']);
    } else {
      this.initPage();
    }
  };

  this.hasViewedRelatedContent = function () {
    // user must view interstitial content or related content only once
    var relatedContentIds = ['main-dashboard-interstitial', 'main-dashboard-crypto-tiers-referral-interstitial'];

    var hasViewedRelatedContent = false;
    for (var idIndex = 0; idIndex < relatedContentIds.length; idIndex++) {
      if (this._productSettings.hasViewedContent('' + relatedContentIds[idIndex])) {
        hasViewedRelatedContent = true;
      }
    }

    return hasViewedRelatedContent;
  };

  this.initPage = function () {
    // this._super(); // optional when need to call the controllers initPage() instead.
    this.initInterstitial();
  };

  this.initAllReady = function () {};

  this.destroy = function () {
    this.destroyInterstitial();
  };
}